module.exports = __webpack_public_path__ + "static/media/infographic2.73d8271a.jpg";